/**
 * Список список шаблонов
 * @return Promise
 */
const templateList = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/templates_statistics/getList",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Объект одного шаблона для статистики
 * data.id - обязательный параметр
 * @return Promise
 */
const templateGet = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/templates_statistics/get",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Добавление нового шаблона для статистики
 * @return Promise
 */
const createTemplate = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/templates_statistics/create",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Редактирование шаблона для статистики
 * @return Promise
 */
const editTemplate = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/templates_statistics/edit",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Удаление шаблона
 * @return Promise
 */
const deleteTemplate = function(data) {
  return new Promise((resolve, reject) =>
    this.request({
      method: "POST",
      url: "/templates_statistics/delete",
      data: data
    })
      .then(resolve)
      .catch(reject)
  );
};
/**
 * Скачивание файла excel
 */
const downloadFileExcel = function(data) {
  return new Promise(resolve => {
    resolve(
      "/api/templates_statistics/downloadFileExcel?type=" +
        data.type +
        "&param=" +
        JSON.stringify(data.param)
    );
  });
};
/**
 * Скачивание файла csv
 */
const downloadFileCSV = function(data) {
  return new Promise(resolve => {
    resolve(
      "/api/templates_statistics/downloadFileCSV?type=" +
        data.type +
        "&param=" +
        JSON.stringify(data.param)
    );
  });
};

export {
  createTemplate,
  templateList,
  templateGet,
  editTemplate,
  deleteTemplate,
  downloadFileExcel,
  downloadFileCSV
};
